<template>
    <div>

        <div class="container" style="margin-top:50px">
            <div class="row">
                <div class="col-lg-12 general-box">

                    <div class="row">
                        <div style="padding:8px 15px; background-color:#f5f5f5; margin-bottom:20px;">
                            <div class="row">
                                <div class="col-xs-6">
                                    <a class="btn btn-link" v-bind:href="'/sheets/' + id">
                                        <i class="fa fa-chevron-left"></i>
                                        Close
                                    </a>
                                </div>
                                <div class="col-xs-6">
                                    <p class="pull-right">
                                        <button class="btn btn-primary" v-on:click="save()">
                                            <i v-if="!saved && !saving" class="fa fa-save"></i>
                                            <i v-if="saving" class="fa fa-circle-o-notch fa-spin"></i>
                                            <i v-if="saved && !saving" class="fa fa-check"></i>
                                            Save
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <!-- Graphic -->
                        <div class="col-md-8 col-md-push-4">
                            <div class="panel panel-default">
                                <div class="panel-body">
                                    <div style="height:400px;" id="graphic"></div>
                                </div>
                            </div>

                        </div>

                        <!-- Editor -->
                        <div class="col-md-4 col-md-pull-8">
                            <div class="row">
                                <div class="col-md-12">
                                    <ul class="nav nav-tabs">
                                        <li :class="{active: tab == 'basic'}"><a v-on:click="tab = 'basic'">Basic</a></li>
                                        <li :class="{active: tab == 'series'}"><a v-on:click="tab = 'series'">Series</a></li>
                                        <li :class="{active: tab == 'range'}"><a v-on:click="tab = 'range'">Range</a></li>
                                    </ul>
                                </div>
                            </div>



                            <div class="row form-horizontal" v-show="tab == 'basic'" style="margin-top:40px;">

                                <div class="col-md-10 col-md-offset-1">

                                    <div class="form-group">
                                        <label class="col-md-12" for="headline">Headline</label>
                                        <div class="col-md-12">
                                            <input class="form-control" id="headline" v-model="headline"/>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class="col-md-12" for="subtitle">Subtitle</label>
                                        <div class="col-md-12">
                                            <input class="form-control" id="subtitle" v-model="subtitle" placeholder="Subtitle"/>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class="col-md-12" for="subtitle">Source</label>
                                        <div class="col-md-12">
                                            <input class="form-control" id="source" v-model="source" placeholder="Source"/>
                                        </div>
                                    </div>

                                    <div class="col-md-offset-2 col-md-10">
                                        <hr>
                                    </div>

                                    <div class="form-group">
                                        <label class="col-md-4">Chart</label>
                                        <div class="col-md-8">
                                            <div class="radio"
                                                 v-for="t in types"
                                            >
                                                <label>
                                                    <input v-model="type" v-bind:value="t.type" type="radio" name="type"><i v-bind:class="t.icon"></i> {{ t.name }}
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class="col-md-4">Data Stacking</label>
                                        <div class="col-md-8">
                                            <div class="radio"
                                                 v-for="t in stackingTypes"
                                            >
                                                <label>
                                                    <input v-model="stacking" v-bind:value="t.type" type="radio" name="stacking">
                                                    {{ t.name }}
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>



                            <div class="row" v-show="tab == 'series'" style="margin-top:40px;">

                                <div class="col-xs-12">
                                    <div class="list-group"

                                    >
                                        <div
                                                v-for="(a,index) in data"
                                                class="list-group-item pointer"
                                                v-bind:style="'border-left:6px solid ' + seriesColor(index)"
                                                :class="{
                                high: active == index,
                                'high-inset': active + 1 == index
                            }"
                                        >

                                            <div
                                                    class="row"

                                            >
                                                <!--<series transition="fade" :data="a" transition-mode="out-in"></series>-->
                                                <!-- editable -->
                                                <div v-show="a.visible" class="col-md-9 col-md-offset-1 panel panel-default paper animated" transition="fade">
                                                    <div class="panel-body">
                                                        <div class="form-horizontal">
                                                            <div class="form-group">
                                                                <label class="col-md-12">
                                                                    Legend
                                                                </label>
                                                                <div class="col-md-12">
                                                                    <input class="form-control" v-model="a.description" v-on:keyup="updateDescription()">
                                                                </div>
                                                            </div>

                                                            <div class="form-group">
                                                                <label class="col-md-12">
                                                                    Unit
                                                                </label>
                                                                <div class="col-md-12">
                                                                    <input class="form-control" v-model="a.unit" v-on:keyup="updateYAxis()">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <!-- control the paper! -->
                                                <div class="col-md-2">
                                                    <button
                                                            class="btn btn-default"
                                                            v-on:click="up(index)"
                                                            v-bind:style="{
                                                                'color:lightgrey' : $index === 0,
                                                                'color:black' : $index !== 0,
                                                            }"
                                                    >
                                                        <i class="fa fa-chevron-up"></i>
                                                    </button>
                                                    <button
                                                            class="btn btn-default"
                                                            v-on:click="down(index)"
                                                            v-bind:style="{
                                                                'color:lightgrey' : $index === data.length - 1,
                                                                'color:black' : $index !== data.length - 1,
                                                            }"
                                                    >
                                                        <i class="fa fa-chevron-down"></i>
                                                    </button>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div class="row" v-show="tab === 'range'" style="margin-top:40px;">
                                <div class="col-xs-12">
                                    <div class="form-horizontal">
                                        <div class="form-group">
                                            <label class="col-md-12">From</label>
                                            <div class="col-xs-8 col-md-8" style="padding-top:8px;">
                                                <input type="range" min="0" v-bind:max="dates.length - 1" v-model="from">
                                            </div>
                                            <div class="col-xs-4 col-md-4">
                                                <select class="form-control" v-model="from">
                                                    <option v-for="(date,index) in dates" v-bind:value="index">
                                                        {{ date }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <hr>

                                        <div class="form-group">
                                            <label class="col-md-12 col-xs-12">To</label>
                                            <div class="col-xs-8 col-md-8" style="padding-top:8px;">
                                                <input type="range" min="0" v-bind:max="dates.length - 1" v-model="to">
                                            </div>
                                            <div class="col-xs-4 col-md-4">
                                                <select class="form-control" v-model="to">
                                                    <option v-for="(date,index) in dates" v-bind:value="index">
                                                        {{ date }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {

        props: {
            id: {
                default: null,
            },
            link: {
                default: null,
            }
        },

        data: function () {
            return {
                colors: ['#7cb5ec', '#434348', '#90ed7d', '#f7a35c', '#8085e9',
                    '#f15c80', '#e4d354', '#2b908f', '#f45b5b', '#91e8e1'], // highcharts default colors
                types: [
                    {name: 'Line', type: 'line', icon: 'fa fa-line-chart'},
                    {name: 'Bar', type: 'bar', icon: 'fa fa-bar-chart fa-rotate-90'},
                    {name: 'Column', type: 'column', icon: 'fa fa-bar-chart'},
                    //{name: 'Pie', type: 'pie', icon: 'fa fa-bar-chart'},
                ],
                stackingTypes: [
                    {name: 'None', type: 'none'},
                    {name: 'Normal', type: 'normal'},
                    {name: 'Percent', type: 'percent'},
                ],
                headline: '',
                data: [],
                href: '',
                type: 'line',
                subtitle: '',
                stacking: 'none',
                source: '',
                yAxis: [],
                saved: true,
                saving: false,
                chart: null,
                series: [],
                token: document.querySelector('#_token').getAttribute('value'),
                active: 0,
                tab: 'basic',
                dates: {},

                from: null,
                to: null,
            }
        },

        mounted: function () {
            if (typeof this.link === 'undefined') {
                this.link = null;
            }

            if (typeof this.id === 'undefined') {
                this.id = null;
            }

            this.load();
        },

        computed: {
            dataWithIndex: function() {
                return this.data.map(function (a, index) {
                    a.index = index;
                    return a;
                });
            }
        },

        watch: {
            headline: 'redraw',
            subtitle: 'redraw',
            source: 'updateSource',
            'type': 'chartType',
            'stacking': 'chartType',
            from: 'updateRangeFrom',
            to: 'updateRangeTo',
        },

        methods: {
            load: function () {
                var that = this;

                if (typeof this.link !== 'undefined' && this.link !== null) {

                    window.http.get('/sheets/link?link=' + this.link).then((response) => {
                        that.createChartFromData(response.data);
                        that.saved = false;
                    });
                }

                if (typeof this.id !== 'undefined' && this.id !== null) {
                    window.http.get('/sheets/' + this.id + '/json').then((response) => {
                        that.createChartFromData(response.data);
                        that.saved = true;
                    });
                }
            },

            createChartFromData: function (data) {

                this.headline = data.headline;
                this.data = data.data.map(function (foo) {
                    foo.visible = true;
                    return foo;
                });
                this.href = data.href;
                this.type = data.type;
                this.subtitle = data.subtitle;
                this.source = data.source;
                this.stacking = data.stacking;
                this.dates = data.dates;
                this.from = data.from == null ? 0 : data.from;
                this.to = (data.to == null ? (data.dates.length - 1) : data.to);

                this.determineUniqueAxis();
                this.updateFromData();
                this.newChart();
            },

            updateFromData: function () {
                var series = [];

                var that = this;

                this.data.forEach(function(field) {
                    //$.each(this.data, function (index, field) {
                    var data = [];
                    //$.each(field.observations, function (key, val) {
                    field.observations.forEach(function (val) {
                        if (that.from != null && that.dates[that.from] > val.time) {
                            return;
                        }

                        if (that.to != null && that.dates[that.to] < val.time) {
                            return;
                        }

                        if (!(val.value != null && val.value !== '')) {
                            return;
                        }

                        data.push([Date.parse(val.time), val.value]);
                    });

                    //this.yAxis.$add(data.unit, data.unit);
                    // get the position for the axis!
                    var yIndex = 0;
                    that.yAxis.forEach(function (axis, index) {
                        if (axis === field.unit) {
                            yIndex = index;
                        }
                    });

                    series.push({
                        name: field.description,
                        data: data,
                        yAxis: yIndex,
                    });
                });

                this.series = series;
            },

            save: function () {

                var that = this;

                that.saving = true;

                var data = {
                    _token: document.querySelector('#_token').getAttribute('value'),
                    headline: this.headline,
                    data: this.data,
                    type: this.type,
                    subtitle: this.subtitle,
                    source: this.source,
                    stacking: this.stacking,
                    from: this.from,
                    to: this.to,
                };

                // if this.id is null, we create a new sheet and obtain the id
                if (typeof this.id === 'undefined' || this.id === null) {

                    data.link = this.link;

                    window.http.post('/sheets', data).then((response) => {
                        that.saved = true;
                        that.saving = false;
                        that.id = response.data.id;
                    });

                } else { // if this.id is not null, we update the sheet

                    data._method = 'put';

                    window.http.post('/sheets/' + this.id, data).then((response) => {
                        that.saved = true;
                        that.saving = false;
                    });

                }

            },

            options: function () {
                return {
                    exporting: {
                        buttons: {
                            contextButton: {
                                enabled: false,
                            }
                        },
                    },
                    plotOptions: {
                        series: {
                            animation: false,
                            stacking: this.stacking === 'none' ? null : this.stacking,
                        }
                    },
                    chart: {
                        renderTo: 'graphic',
                        type: this.type,
                        zoomType: null, // not zoomable!
                    },
                    title: {
                        text: this.headline,
                    },
                    subtitle: {
                        text: this.subtitle,
                    },
                    series: this.series,
                    yAxis: this.yAxis.map(function (title) {
                        return {
                            title: {
                                text: title
                            }
                        };
                    }),
                    legend: {
                        itemStyle: {
                            width: 550,
                        },
                    },
                    'credits': {
                        enabled: this.source.length > 0,
                        text: this.source,
                        href: '',
                    },
                };
            },

            updateSource: function () {
                this.saved = false;
                this.newChart();
            },

            exportChart: function (type) {
                this.chart.exportChart({type: type});
            },

            determineUniqueAxis: function () {
                this.yAxis = [];
                this.yAxis = this.data.map(function (data) {
                    return data.unit
                }).sort().filter(function (item, pos, ary) {
                    return !pos || item !== ary[pos - 1];
                });
            },
            updateYAxis: function () {
                this.saved = false;
                var oldLength = this.yAxis.length;

                this.determineUniqueAxis();
                this.updateFromData();

                var that = this;

                // the count of unit axis changed - we redraw from scratch!
                if (this.yAxis.length !== oldLength) {
                    return this.newChart();
                }

                // just rename the units
                var i = 0;
                this.yAxis.forEach(function (title) {
                    that.chart.yAxis[i].setTitle({
                        text: title,
                    });
                    i++;
                });
            },
            updateDescription: function () {
                this.saved = false;
                this.updateFromData();

                this.newChart();
            },
            hard: function () {
                this.chart.yAxis[0].setTitle({
                    'text': this.yAxis[0],
                });
            },

            redraw: function () {
                this.saved = false;
                this.chart.setTitle({
                    text: this.headline,
                }, {
                    text: this.subtitle,
                });
            },

            chartType: function () {
                this.saved = false;
                this.newChart();
            },

            newChart: function () {
                this.chart = null;
                this.chart = new Highcharts.Chart(this.options());
            },

            up: function (index) {
                if (index === 0) {
                    return;
                }

                this.swap(index, index - 1);
            },

            down: function (index) {
                if (index === this.data.length - 1) {
                    return;
                }

                this.swap(index, index + 1);
            },

            swap: function (one, two) {

                this.data[one].visible = false;
                this.data[two].visible = false;

                //this.$nextTick(function () {
                var that = this;
                setTimeout(function () {
                    var dummy = that.data[one];
                    //that.data.$set(one, that.data[two]);
                    Vue.set(that.data, one, that.data[two]);
                    //that.data.$set(two, dummy);
                    Vue.set(that.data, two, dummy);

                    that.data[one].visible = true;
                    that.data[two].visible = true;

                    that.saved = false;
                    that.determineUniqueAxis();
                    that.updateFromData();
                    that.newChart();
                }, 950);

            },

            updateRangeFrom: function () {
                if (this.to < this.from) {
                    this.to = this.from;
                }
                this.updateRange();
            },

            updateRangeTo: function () {
                if (this.from > this.to) {
                    this.from = this.to;
                }
                this.updateRange();
            },

            updateRange: function () {
                this.saved = false;
                this.determineUniqueAxis();
                this.updateFromData();
                this.newChart();
            },

            seriesColor: function (index) {
                return this.colors[index % 10];
            },

        },

    }

</script>
